<template>
  <div class="card-body activity-exam-marks">
    <div class="card height-auto v-application--is-ltr text-left">
      <div class="card-body">
        <v-row class="headerTable-div">
          <v-col md="4" sm="12">
            <p class="title mb-0" style="text-align: left">
              <span class="main-color">
                {{ page_title }}
              </span>
              <span> / {{ qualifierName }} </span>
            </p>
            <p class="font-weight-bold small" style="text-align: left">
              {{ breadcrumb }}
            </p>
          </v-col>
          <v-col md="6" sm="12"></v-col>
        </v-row>
        <v-divider
          style="background-color: #ddd !important; margin-bottom: 20px"
          class="mt-4 mb-4 main-color"
        ></v-divider>
        <v-row>
          <div class="card-body">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              style="overflow-x: auto"
              :headers="headers"
              :items="students"
              item-key="id"
              :show-select="false"
              class="elevation-1 level1 templates font-weight-light"
              text="left"
              hide-default-header
              hide-default-footer
              disable-pagination
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr class="elevation-0">
                    <th v-for="(headerItem, index) in headers" :key="index" style="text-align-last: center">
                      <p class="mb-0 " v-if="headerItem.value == 'name' || headerItem.value == 'student_activities_total_mark_percentage'" @click="changeSort(headerItem.value)">
                        {{ headerItem.text }}
                        <v-icon small v-if="Object.keys(options).length === 0  || options.sortDesc == false">mdi-arrow-up</v-icon>
                        <v-icon small v-else-if="options.sortDesc == true">mdi-arrow-down</v-icon>
                      </p>
<!--                      <p-->
<!--                        class="mb-0"-->
<!--                        v-else-if="-->
<!--                          headerItem.value == 'student_activities_total_mark_percentage'-->
<!--                        "-->
<!--                      >-->
<!--                        {{ headerItem.text }}-->
<!--                      </p>-->
                      <p
                        class="mb-0"
                        v-else-if="
                          headerItem.value == 'student_activity_total_mark'
                        "
                      >
                        {{ headerItem.text }} <br />
                        <span class="mb-0 small font-weight-bold">
                          ( {{ qualifierTotalMark }} )
                        </span>
                      </p>
                      <router-link v-else :to="'#'">
                        {{ headerItem.text }}
                        <p class="mb-0 small font-weight-bold">
                          ( {{ headerItem.full_mark }} )
                        </p>
                      </router-link>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:item="{ item }">
                <tr class="elevation-0">
                  <td
                    v-for="(itemData, propertyName, index) in item"
                    :key="index"
                    style="text-align-last: center"
                  >
                    <p class="mb-0" v-if="propertyName == 'name'">
                      {{ itemData }}
                    </p>
                    <p
                      class="mb-0"
                      :style="{
                        color: !itemData.mark_is_confirmed ? 'red' : '',
                      }"
                      v-else-if="
                        propertyName != 'name' &&
                        propertyName != 'student_activity_total_mark' &&
                        propertyName !=
                          'student_activities_total_mark_percentage'
                      "
                    >
                      {{ itemData.mark }}
                    </p>
                    <p
                      class="mb-0"
                      v-else-if="propertyName == 'student_activity_total_mark'"
                    >
                      {{ itemData }}
                    </p>
                    <p
                      class="mb-0"
                      v-else-if="
                        propertyName ==
                        'student_activities_total_mark_percentage'
                      "
                    >
                      {{ itemData }}
                    </p>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-row>
      </div>
    </div>

    <v-snackbar
      v-model="snack"
      :timeout="snackTime"
      :color="snackColor"
      :right="true"
      :top="true"
    >
      <!-- {{ snackText }} -->

      <span class="white--text">{{ snackText }}</span>

      <v-btn text @click="snack = false">{{ $t("Close") }}</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
// import addEditExamComponent from "../../components/modals/addEditExamComponent";
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "ConfirmedMarksSubjectQualifiers",
  // components: { addEditExamComponent },
  mixins: [validationMixin],
  data() {
    return {
      options: { },
      // options: {
      //   itemsPerPage: 15,
      // },
      // page: 1,
      // length: "",
      // totalVisible: "",
      // totalItems: "",
      valid: false,
      loading: false,
      snackTime: 3000,
      snackColor: "success",
      snackText: "",
      snack: false,
      page_title: "",
      qualifierName: "",
      qualifierTotalMark: "",
      breadcrumb: "",
      selectedSemester: "",
      selectedQuarter: "",
      selectedGrade: "",
      selectedClass: "",
      academicGradeSubjectId: "",
      headers: [],
      subjectQualifiers: [],
      search: "",
      errorEmptyItems: "",
      // selected: [],
    };
  },
  
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    changeSort(column) {
      this.options={sortBy: column, sortDesc: !this.options.sortDesc }
    },
    getData() {
      if (this.selectedClass != "" && this.academicGradeSubjectId != "") {
        this.loading = true;
        let sort_desc = "";
        let column = "";
        if (this.options.sortBy && this.options.sortBy) {
          column = this.options.sortBy;
          sort_desc = this.options.sortDesc;
        }

        axios
            .get(
                this.getApiUrl +
                "/performance/getConfirmedMarksSubjectQualifierActivitiesData/" +
                this.selectedQuarter +
                "/" +
                this.selectedClass +
                "/" +
                this.academicGradeSubjectId +
                "/" +
                this.subjectQualifierQuarterId +
                "?sort_desc=" +
                sort_desc +
                "&column=" +
                column
                ,
                {
                  headers: {
                    Authorization: "Bearer " + localStorage.token,
                    //the token is a variable which holds the token
                  },
                }
            )
            .then((response) => {
              this.loading = false;
                /*
                * every classStudent is the data of every row in the table
                * every row is object consists of keys of subjects with their values every value is equal to the mark of student
                * and key of the name with its value is equal to the student name  
                */
              this.students = response.data.data.classStudents;
              this.page_title = response.data.data.page_title;
              this.qualifierName = response.data.data.qualifier.title;
              this.qualifierTotalMark = response.data.data.qualifier_total_mark || "";
              this.breadcrumb = response.data.data.breadcrumb;
              // the first column (header data) 
              this.headers = [{
                text: 'Student Name',
                value: "name",
                sortable: false,
                align: "center",
              },
            ];
            this.headers = this.headers.concat(
              /*
               * every activity is object consists of keys:
               * text key that represents name of the subject to be shown as {{{{ header }}}} cell
               * value key that represents name of the subject also because backend response with data represents every student consists of keys equal to the subject names and values equal to the student mark of the subject.
               */
              response.data.data.subjectQualifierActivities.map(
                (subjectQualifierActivity) => {
                  return {
                    text: subjectQualifierActivity["name"],
                    value: subjectQualifierActivity["name"],
                    full_mark: subjectQualifierActivity["mark"],
                    // qualifier_total_mark: subjectQualifierActivity['qualifier_total_mark'],
                    sortable: false,
                    align: "center",
                  };
                }
              )
            );

            // header column for total mark of the qualifier
            this.headers = this.headers.concat(
              {
                text: response.data.data.calculationType,
                value: "student_activity_total_mark",
                sortable: false,
                align: "center",
              },
              {
                text: "Percentage",
                value: "student_activities_total_mark_percentage",
                sortable: false,
                align: "center",
              }
            );
          });
      }
    },
  },
  mounted() {
    this.selectedQuarter = this.$router.currentRoute.params.quarterId;
    this.selectedClass = this.$router.currentRoute.params.classId;
    this.academicGradeSubjectId =
      this.$router.currentRoute.params.academicGradeSubjectId;
    this.subjectQualifierQuarterId =
      this.$router.currentRoute.params.subjectQualifierQuarterId;
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

// end search input
.title-page {
  margin-top: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.card-container {
  max-width: 80%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
.actions-container {
  position: relative;
}
.actions {
  position: absolute;
  top: -10px;
  right: 22px;
}
.actions i,
.actions span {
  cursor: pointer;
}
.actions span {
  margin-left: 5px;
}

.title-qualifire .divider {
  margin-top: 10px;
  margin-bottom: 10px;
}
.q-box-title {
  font-size: 29px;
  position: relative;
}

.q-box-title h2 {
  font-size: 25px;
  padding: 0;
  margin: 0;
}

.title-page {
  margin-top: 15px;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #eef3ff;
  margin-bottom: 33px;
}
.v-expansion-panel-content {
  background-color: #f7f7f7;
}
.title-panel {
  color: rgb(114, 151, 255);
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
.details {
  margin-top: 6%;
  overflow: hidden;
}
.details span {
  color: #8d8a8a;
  font-size: 17px;
  font-weight: 700;
}
.details span.passing {
  float: right;
}
.v-expansion-panel-content__wrap {
  padding: 0;
}
.space-name {
  margin-top: -15px !important;
}

.betweencolon {
  position: absolute;
  top: 3rem;
  left: 5%;
}

.dur-error {
  margin-top: 0 !important;
}
.maxSize {
  font-size: 10px;
}
.text-left,
.text-left th,
.text-left td {
  text-align: left !important;
}
</style>
